export default "__VITE_ASSET__BOu5U4SI__"